import dynamic from 'next/dynamic'

export const MossUIField = dynamic({
  loader: () => import('@getmoss/lib-ui-components/moss-ui').then((mod) => mod.Field),
  ssr: false,
})

export const MossUICheckbox = dynamic({
  loader: () => import('@getmoss/lib-ui-components/moss-ui').then((mod) => mod.Checkbox),
  ssr: false,
})

export const MossUISelect = dynamic({
  loader: () => import('@getmoss/lib-ui-components/moss-ui').then((mod) => mod.Select),
  ssr: false,
})

export const MossUIMenuItem = dynamic({
  loader: () => import('@getmoss/lib-ui-components/moss-ui').then((mod) => mod.MenuItem),
  ssr: false,
})

export const MossUIMenuItemLabel = dynamic({
  loader: () => import('@getmoss/lib-ui-components/moss-ui').then((mod) => mod.MenuItem).then((mod) => mod.Label),
  ssr: false,
})

const MossUIComponents = {
  Field: MossUIField,
  Checkbox: MossUICheckbox,
  Select: MossUISelect,
  MenuItem: MossUIMenuItem,
  MenuItemLabel: MossUIMenuItemLabel,
}

export default MossUIComponents
